import * as Sentry from '@sentry/react';
import { get } from 'lodash-es';

// Often times sites coming from API integrations does not have coordinates. This is totally
// allowed by the API, but the FE expects them. Sites without coordinates will end up in console
// errors and other side effects in the UI, but for the latter our users already know that will
// have to go and edit the site to add coordinates.
export function ignoreSiteMissingCoordinates(event: Sentry.ErrorEvent) {
  const message = event.message ?? '';
  const isSiteMissingCoordinatesError =
    message.includes('InvalidValueError"') &&
    message.includes('NaN is not an accepted value');

  // "pixelsToWorld" lives in the Google Maps API library, and appears in the stacktrace when
  // the map fails to render due to missing coordinates.
  const stacktrace = get(event, 'exception.values.0.stacktrace.frames', []);
  const hasPixelsToWorldFunction = stacktrace.some((frame) => {
    return frame.function === 'pixelsToWorld';
  });

  return isSiteMissingCoordinatesError || hasPixelsToWorldFunction;
}
